const validateEmail = email => {
    return email.match(/^\S+@\S+\.\S+$/);
  };
  
  export {validateEmail};
  